export function toUnit(value, fromUnit, toUnit, unitOptions) {
  if (fromUnit === toUnit) return value;
  const fromOpt = unitOptions.find((u) => u.unit === fromUnit);
  const toOpt = unitOptions.find((u) => u.unit === toUnit);
  if (!fromOpt || !toOpt) return value;
  return (value * fromOpt.weight) / toOpt.weight;
}

export function fmtQty(n) {
  if (n == null || isNaN(n)) return "";
  return String(parseFloat(n.toFixed(3)));
}

export function qtyFeedbackType(entered, suggested) {
  const e = parseFloat(entered);
  if (isNaN(e) || suggested <= 0) return null;
  if (e < suggested - 0.001) return "below";
  if (e > suggested + 0.001) return "above";
  return null;
}
